import React from 'react';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { queryTable,Table as CommonTable } from 'common/types/disco/table';

type SimpleTableProps = {
  table?: CommonTable;
  columnNames: string[];
  headers: string[];
};

const SimpleTable: React.FC<SimpleTableProps> = ({ table, columnNames, headers }) => {
  const columnIndices = queryTable(table).columnIndices(...columnNames);

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table size="small" sx={{ minWidth: 200 }}>
        <TableHead>
          <TableRow>
            {headers.map((header, idx) => (
              <TableCell key={`${header}-${idx}`}>
                <Typography fontWeight="bold">{header}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {table?.rows.map((row, rowIdx) => (
            <TableRow key={`row-${rowIdx}`}>
              {columnIndices.map(colIdx => (
                <TableCell key={`col-${colIdx}`}>{row[colIdx]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SimpleTable;
